var map = {
	"./Alien_symbol_0.png": "d223",
	"./Alien_symbol_1.png": "4213",
	"./Alien_symbol_2.png": "3f8e",
	"./Alien_symbol_3.png": "f3a8",
	"./Alien_symbol_4.png": "321c",
	"./Alien_symbol_5.png": "0d5c",
	"./Alien_symbol_6.png": "299b",
	"./Alien_symbol_7.png": "1563",
	"./Alien_symbol_8.png": "6e35",
	"./Alien_symbol_9.png": "b25c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "055f";